<app-tile title="Messages" [hasDivider]="true">
  <section class="d-flex flex-wrap icons-container ps-3 pe-3 fs-1 gap-3">
    <i class="fa-brands fa-facebook" style="color: #3b5998"></i>
    <i class="fa-brands fa-twitter" style="color: #00acee"></i>
    <i class="bi bi-chat-left-text"></i>
    <i class="bi bi-envelope"></i>
  </section>
</app-tile>
